import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { MainLayout } from "../layouts/MainLayout";
import BasePage from "./BasePage";
import { AuthPage } from "../pages/auth";
import ErrorsPage from "../pages/error/ErrorsPage";
import Auth from "../helpers/Auth";
import { useAuth } from "../hooks/useAuth";
import { PermissionProvider } from "../contexts/PermissionContext";

export function Routes() {
  const { user } = useAuth();

  if (!Auth.isUserAuthenticat()) {
    return (
      <RouterRoutes>
        <Route path="/auth/*" element={<AuthPage />} />
        <Route path="/changepassword" element={<AuthPage />} />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </RouterRoutes>
    );
  }

  return (
    <RouterRoutes>
      <Route path="/auth/login" element={<Navigate to="/" replace />} />
      <Route path="/error/*" element={<ErrorsPage />} />
      <Route
        path="/*"
        element={
          <PermissionProvider user={user}>
            <MainLayout>
              <BasePage />
            </MainLayout>
          </PermissionProvider>
        }
      />
    </RouterRoutes>
  );
}
